window.addEventListener("load", () => {
  setTimeout(() => {
    let btnnn = document.querySelector("#shopify-pc__banner__btn-accept")
    let banner = document.querySelector("#shopify-pc__banner")
    if (btnnn) {
      btnnn.addEventListener("click", () => {
      })
    }
  }, 3000)
})

let checkScroll = () => {
  let height = window.innerHeight
  let menu = document.querySelector('[menu-container]')
  if (menu.getAttribute('isactive') != undefined) {
    if (window.scrollY != 0) {
      menu.classList.add('active')
    }
    else {
      menu.classList.remove('active')
    } 
  }
  else {
    return
  }
}
window.addEventListener("load", () => {
  checkScroll()
  window.addEventListener("scroll", () => {
    checkScroll()
  })
})

var runCommand = () => {
setTimeout(() => {
  let container = document.querySelector('[zu-favoritos]')
  let sample = document.querySelector('[favorite_sample] .mix')
  let grid = document.querySelector('[favorite_grid]')
  let favorites = document.querySelectorAll('[product_handle]')
  let loading = document.querySelector('[favorite_loading]')
  let promises = []
  let elements = []
  let count = 0
  favorites.forEach((e) => {
    let handle = e.getAttribute('product_handle')
    promises.push(fetch(window.Shopify.routes.root + `products/${handle}.js`).then(response => response.json()))
    let newCount = 0
    let id = null
    let parr = e
    while (id == null && newCount < 10) {
      parr = parr.parentNode
      let ele = parr.querySelector('[data-wishlist-item-id]')
      if (ele != undefined) {
        id = ele.getAttribute('data-wishlist-item-id')
      }
      newCount++
    }
    elements.push({
      id,
      handle
    })
  })
  Promise.all(promises)
  .then((data) => {
    data.forEach((e) => {
      count++
      let newElement = sample.cloneNode(true)
      newElement.querySelector('[product_title]').innerHTML = e.title
      newElement.querySelector('[product_time]').classList.add('tlw-hidden')
      let tmp = document.createElement("DIV")
      tmp.innerHTML = e.description
      desc = tmp.textContent || tmp.innerText || ""
      if (desc.length > 80) {
        desc = desc.substring(0, 80) + '...'
      }
      newElement.querySelector('[product_description]').innerHTML = desc
      if (e.featured_image != undefined) {
        newElement.querySelector('[product_img]').setAttribute('src', e.featured_image)
      }
      newElement.querySelector('[product_url]').setAttribute('href', e.url)
      let idd = null
      elements.forEach((ee) => {
        if (ee.handle == e.handle) {
          idd = ee.id
        }
      })
      if (idd != null) {
        newElement.querySelector('[remove_button]').innerHTML = `
          <remove-button data-wishlist-item-id="${idd}" show-icon=""></remove-button>
        `
      }
      newElement.querySelector('[remove_button]').addEventListener('click', () => {
        location.replace(location.href)
      })
      e.tags.forEach((tag) => {
        tag = tag.replace(/\s/g, '')
        newElement.classList.add(tag)
        if (tag == 'desayunos' || tag == 'comidas' || tag == 'cenas' || tag == 'snacks' || tag == 'postres' || tag == 'snaks') {
          newElement.classList.add('food')
        }
        else if (tag == 'do' || tag == 'listen') {
          newElement.classList.add('mindset')
        }
        else if (tag == 'arrise' || tag == 'zwo' || tag == 'matchbox') {

          newElement.classList.add('zwo')
        }
        else {
          newElement.classList.add('selfcare')
        }
      })
      grid.append(newElement)
    })
    setTimeout(() => {
      var containerEl = document.querySelector('[favorite_grid]')
      var mixer = mixitup(containerEl)
    }, 3000)
    return data
  })
  .catch(function handleError(error) {
    console.log("Error" + error)
  })
  .finally(() => {
    let url = new URL(window.location.href)
    if (count != 0) {
      loading.classList.add('tlw-hidden')
    }
    else {
      loading.querySelector('h1').innerText = `No hay resultados`
    }
    if (url.pathname.toString().includes("wishlist")) {
      container.classList.remove('tlw-hidden')
    }
  })
}, 500)
}
window.addEventListener("runCommand", runCommand, false)

let add = (data) => {
fetch(window.Shopify.routes.root + 'cart/clear.js', {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json'
  }
})
.then(response => {
  return response.json()
})
.then(response => {
  let formData = {
    'items': [data]
  }
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json()
  })
  .then(response => {
    console.log(response)
  })
  .catch((error) => {
    console.error('Error:', error)
  })
  .finally((res) => {
    window.location.href = '/checkout'
  })
})
.catch((error) => {
  console.error('Error:', error)
})
}
window.addEventListener('load', () => {
let buttons = document.querySelectorAll('[add-membership]')
buttons.forEach((e) => {
  e.addEventListener('click', () => {
    let selling_plan = e.getAttribute('selling_plan')
    let product_id = e.getAttribute('product-id')
    let id = e.getAttribute('id')
    add({
      selling_plan,
      product_id,
      id,
      quantity: 1
    })
  })
})
})

function modal() {
let div = document.querySelector('#modal')
if(div.style.display == "none") {
    div.style.display = "block"
  }
  else {
  div.style.display = "none"
}
}
window.addEventListener("load", () => {
let elements = document.querySelectorAll('[open-modal]')
let url = new URL(window.location.href)
if (url.searchParams.get('modal') != null) {
  modal()
}
elements.forEach((eee) => {
  eee.classList.add('tlw-cursor-pointer')
  if (eee.nodeName == 'A') {
    eee.removeAttribute('href')
  }
  eee.addEventListener("click", () => {
    modal()
  })
})
})



const iframes = document.querySelectorAll('iframe[vimeo]')
iframes.forEach((e) => {
const player = new Vimeo.Player(e)
player.on('play', function() {
  console.log('played the video!')
})
player.getVideoTitle().then(function(title) {
  console.log('title:', title)
})
player.on('ready', function() {
  player.setColor('#ffffff')
})
window.addEventListener("load", () => {
  player.setColor('#ffffff')
})
})



let elem = document.querySelector('[idd]')
let infScroll = new InfiniteScroll( elem, {
path: '.pagination__next',
append: '.zuhub-card',
button: '.pagination__next',
scrollThreshold: false,
history: false
})